// extracted by mini-css-extract-plugin
module.exports = {"root":"IcoMoon_root__1rjQB","variant1":"IcoMoon_variant1__3-qIn"};